var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"each-component"},[_c('div',{staticClass:"flex-center position-ref full-height"},[_c('div',{staticClass:"text-left padding-x30"},[_c('h1',[_vm._v("Access Denied")]),_vm._v(" "),_c('p',[_vm._v("Access is denied. You may not have the appropriate permissions to access the page or perform the action.")])])])])
}]

export { render, staticRenderFns }